
// src/common/FullPageLoader.jsx
import React from "react";

const FullPageLoader = ({ size = 60 }) => {
  return (
    <div className="absolute inset-0 bg-white/60 backdrop-blur-md flex justify-center items-center z-[100]">
      <div
        className="animate-spin rounded-full border-4 border-gray-100"
        style={{
          width: size,
          height: size,
          borderTopColor: "#8B7359",
        }}
      ></div>
    </div>
  );
};

export default FullPageLoader;

